import { render, staticRenderFns } from "./terminals.vue?vue&type=template&id=a3de6abc&"
import script from "./terminals.vue?vue&type=script&lang=js&"
export * from "./terminals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports